/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import ContactosService from "common/services/ContactosService"
import { approvalsServices } from "features/User/pages/ApprovalsManagement/services/approvals"

export const fetchAprovalList = createAsyncThunk(
  "FlujoAprobacion/all",
  // @ts-expect-error TS(6133): 'thunkAPI' is declared but its value is never read...
  async (_, thunkAPI) => {
    const { data: aprobaciones } = await approvalsServices.fetchAprovalList()
    return aprobaciones
  }
)
export const fetchAprovalById = createAsyncThunk(
  `FlujoAprobacion/id`,
  async (id) => {
    const { data: aprobaciones } = await approvalsServices.fetchAprovalById(id)
    return aprobaciones
  }
)
export const fetchApprovalsByContacto = createAsyncThunk(
  "/Contacto/id/flujo-aprobaciones",
  async (id) => {
    const { data } = await ContactosService.getFlujoAprobacionesContacto(id)

    return data
  }
)

const initialState = {
  aprobaciones: [],
  aprobacionesStatus: false,
  aprobacionItem: {},
  aprobacionItemStatus: false,
}

export const aprobacionesSlice = createSlice({
  name: "aprobaciones",
  initialState,
  reducers: {
    resetApprovals(state) {
      state.aprobaciones = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAprovalList.rejected, (state) => {
        state.aprobacionesStatus = false
      })
      .addCase(fetchAprovalList.pending, (state) => {
        state.aprobacionesStatus = true
      })
      .addCase(fetchAprovalList.fulfilled, (state, { payload }) => {
        state.aprobaciones = payload
        state.aprobacionesStatus = false
      })
      .addCase(fetchAprovalById.rejected, (state) => {
        state.aprobacionItemStatus = false
      })
      .addCase(fetchAprovalById.pending, (state) => {
        state.aprobacionItemStatus = true
      })
      .addCase(fetchAprovalById.fulfilled, (state, { payload }) => {
        state.aprobacionItem = payload
        state.aprobacionItemStatus = false
      })
      .addCase(fetchApprovalsByContacto.pending, (state) => {
        state.aprobacionesStatus = true
      })
      .addCase(fetchApprovalsByContacto.rejected, (state) => {
        state.aprobacionesStatus = false
      })
      .addCase(fetchApprovalsByContacto.fulfilled, (state, { payload }) => {
        state.aprobacionesStatus = false
        state.aprobaciones = payload
      })
  },
})

export const { resetApprovals } = aprobacionesSlice.actions
